import { ApolloProvider } from "@apollo/client";
// import "antd/dist/antd.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import client from "./client/ApolloClient";
import ErrorBoundary from "./components/common/ErrorBoundary";
// import "./index.css";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <ErrorBoundary>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
